import axios from "axios";
import { useEffect, useState } from "react";
import useGlobalContext from "../../../../hooks/useGlobalContext";
import localize from "../../../../common/localize";
import SignatureBox from "./SignatureBox";

export default function DynamicFormSignature({ signatureField, isOriginal }) {
  const { DYNAMIC_FORM_FIELD_VALUE_ENDPOINT, config } = useGlobalContext();
  const [imageBlob, setImageBlob] = useState();

  const downloadEvidence = async () => {
    const image = await axios({
      ...config,
      method: "get",
      responseType: "blob", // Force to receive data in a Blob Format
      url: `${DYNAMIC_FORM_FIELD_VALUE_ENDPOINT}/field/${signatureField?.FieldValue?.Id}/download/${isOriginal}`,
    });

    if (image?.data) {
      const blob = new Blob([image.data], {
        type: "application/octet-stream",
      });

      const urlBlob = URL.createObjectURL(blob);

      setImageBlob(urlBlob);
    }
  };

  useEffect(() => {
    if (signatureField?.FieldValue?.Id > 0) {
      downloadEvidence();
    }
  }, [signatureField?.FieldValue?.Id]);

  return (
    <SignatureBox
      widthValue="100%"
      title={signatureField?.FormField?.Title ?? localize.signature}
      imageBlob={imageBlob}
    />
  );
}
